import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import TopicLabelsAPI from '../../api/topicLabels';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { TOPIC_LABEL_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getTopicLabels(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getTopicLabelsOnSidebar(_state) {
    return _state.records
      .filter(record => record.show_on_sidebar)
      .sort((a, b) => a.title.localeCompare(b.title));
  },
};

export const actions = {
  revalidate: async function revalidate({ commit }, { newKey }) {
    try {
      const isExistingKeyValid = await TopicLabelsAPI.validateCacheKey(newKey);
      if (!isExistingKeyValid) {
        const response = await TopicLabelsAPI.refetchAndCommit(newKey);
        commit(types.SET_TOPIC_LABELS, response.data.payload);
      }
    } catch (error) {
      // Ignore error
    }
  },

  get: async function getTopicLabels({ commit }) {
    commit(types.SET_TOPIC_LABEL_UI_FLAG, { isFetching: true });
    try {
      const response = await TopicLabelsAPI.get(true);
      commit(types.SET_TOPIC_LABELS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_TOPIC_LABEL_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createTopicLabels({ commit }, payload) {
    commit(types.SET_TOPIC_LABEL_UI_FLAG, { isCreating: true });
    try {
      const response = await TopicLabelsAPI.create(payload);
      AnalyticsHelper.track(TOPIC_LABEL_EVENTS.CREATE);
      commit(types.ADD_TOPIC_LABEL, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_TOPIC_LABEL_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateTopicLabels({ commit }, { id, ...updateObj }) {
    commit(types.SET_TOPIC_LABEL_UI_FLAG, { isUpdating: true });
    try {
      const response = await TopicLabelsAPI.update(id, updateObj);
      AnalyticsHelper.track(TOPIC_LABEL_EVENTS.UPDATE);
      commit(types.EDIT_TOPIC_LABEL, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_TOPIC_LABEL_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteTopicLabels({ commit }, id) {
    commit(types.SET_TOPIC_LABEL_UI_FLAG, { isDeleting: true });
    try {
      await TopicLabelsAPI.delete(id);
      AnalyticsHelper.track(TOPIC_LABEL_EVENTS.DELETED);
      commit(types.DELETE_TOPIC_LABEL, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_TOPIC_LABEL_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_TOPIC_LABEL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_TOPIC_LABELS]: MutationHelpers.set,
  [types.ADD_TOPIC_LABEL]: MutationHelpers.create,
  [types.EDIT_TOPIC_LABEL]: MutationHelpers.update,
  [types.DELETE_TOPIC_LABEL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

